import { Avatar, AvatarFallback } from "../ui/avatar";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export function Metrics({ type, data }) {
  if (type === "User") {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Dashboard Metrics</CardTitle>
          <CardDescription>
            Number of Buyers, Sellers and Request
          </CardDescription>
        </CardHeader>
        <CardContent className="flex-1 pb-5">
          <div className="space-y-5">
            <div className="flex items-center">
              <Avatar className="h-9 w-9">
                <AvatarFallback>B</AvatarFallback>
              </Avatar>
              <div className="ml-4 space-y-1">
                <p className="text-sm font-semibold leading-none">Buyers</p>
                <p className="text-sm text-muted-foreground">
                  Buyers on our platform
                </p>
              </div>
              <div className="ml-auto font-bold text-[#0C5C63]">
                {data?.buyerCount}
              </div>
            </div>
            <div className="flex items-center">
              <Avatar className="flex h-9 w-9 items-center justify-center space-y-0 border">
                <AvatarFallback>S</AvatarFallback>
              </Avatar>
              <div className="ml-4 space-y-1">
                <p className="text-sm font-semibold leading-none">Sellers</p>
                <p className="text-sm text-muted-foreground">
                  Sellers on our platform
                </p>
              </div>
              <div className="ml-auto font-bold text-[#0C5C63]">
                {data?.sellerCount}
              </div>
            </div>
            <div className="flex items-center">
              <Avatar className="h-9 w-9">
                <AvatarFallback>BO</AvatarFallback>
              </Avatar>
              <div className="ml-4 space-y-1">
                <p className="text-sm font-semibold leading-none">Buy Offers</p>
                <p className="text-sm text-muted-foreground">
                  Buy offers on our platform
                </p>
              </div>
              <div className="ml-auto font-bold text-[#0C5C63]">
                {data?.buyerRequestCount}
              </div>
            </div>
            <div className="flex items-center">
              <Avatar className="h-9 w-9">
                <AvatarFallback>SO</AvatarFallback>
              </Avatar>
              <div className="ml-4 space-y-1">
                <p className="text-sm font-semibold leading-none">
                  Sell Offers
                </p>
                <p className="text-sm text-muted-foreground">
                  Sell offers on our platform
                </p>
              </div>
              <div className="ml-auto font-bold text-[#0C5C63]">
                {data?.sellerRequestCount}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  const typeMap = {
    Buy: data.topBuyerCombos,
    Sell: data.topSellerCombos,
    Agent: data.topAgents,
  };
  const metric = typeMap[type];

  if (type === "Agent") {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Agent Metrics</CardTitle>
          <CardDescription>Top 5 most active agents</CardDescription>
        </CardHeader>
        <CardContent className="flex-1 pb-5">
          <div className="space-y-5">
            {metric.map((item, index) => (
              <div key={index} className="flex items-center">
                <Avatar className="h-9 w-9">
                  <AvatarFallback>{item?.name.charAt(0)}</AvatarFallback>
                </Avatar>
                <div className="ml-4 space-y-1">
                  <p className="text-sm font-semibold leading-none">
                    {item?.name}
                  </p>
                  <p className="text-sm text-muted-foreground">{item?.email}</p>
                </div>
                <div className="ml-auto font-bold text-[#0C5C63]">
                  {item?.count}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{type} Metrics</CardTitle>
        <CardDescription>
          {`Top 5 ${type} most active products`}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-5">
        <div className="space-y-5">
          {metric.map((item, index) => (
            <div key={index} className="flex items-center">
              <Avatar className="h-9 w-9">
                <AvatarFallback>{item?.grade.charAt(0)}</AvatarFallback>
              </Avatar>
              <div className="ml-4 space-y-1">
                <p className="text-sm font-semibold leading-none">
                  {item?.grade}
                </p>
                <p className="text-sm text-muted-foreground">{item?.form}</p>
              </div>
              <div className="ml-auto font-bold text-[#0C5C63]">
                {item?.count}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
